export class ApiToken {

  private _userId: number
  private _expirationTimestamp: number
  private _rawToken: string
  private _issuingTestline: string

  constructor(apiToken: string) {
    const tokenInfo = (apiToken.split instanceof Function) ? JSON.parse(atob(apiToken.split('.')[1])) : {}
    this._rawToken = apiToken
    this._userId = tokenInfo.mp_user_id
    this._expirationTimestamp = tokenInfo.exp
    this._issuingTestline = tokenInfo.mp_iss_testline
  }

  public getUnverifiedUserId(): number {
    return this._userId
  }

  public getUnverifiedExpirationTimestamp(): number {
    return this._expirationTimestamp
  }

  public getRawToken(): string {
    return this._rawToken
  }

  public isVerified(): boolean {
    return false
  }

  public getIssuingTestline() {
    return this._issuingTestline
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/api-token/api-token.ts